import React, { useState, useEffect, useRef } from 'react'
import './Css'
import Head from './Head'
import Router from './Router'
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import reducer from './redux/reducer'
import { Config, IISMethods } from './config/IISMethods'
// for scss
import '../src/assets/main-css/style.scss'
import './assets/css/printdocumentstyle.css'
import "suneditor/dist/css/suneditor.min.css"
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { getMsalConfig } from './msalConfig';
import { fetchMsalConfig } from './msalConfig';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import LogoLoader from './view/Components/LogoLoader'
import MemoryMonitor from './MemoryMonitor'


//  Aniket Bhesaniya 🛠️  ~ 2025-12-23 ~ 015:14 PM
// connect to redux store 
const isProd = Config.getServermode() === 'prod' ;

//  Aniket Bhesaniya 🛠️  ~ 2025-12-23 ~ 015:14 PM
const isDebugEnabled =
  !isProd ||
  localStorage.getItem('ENABLE_DEBUG') === 'BizConfig@.$000'
export const store = createStore(reducer, isDebugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() : f => f)
//  Aniket Bhesaniya 🛠️  ~ 2025-12-23 ~ 015:14 PM
if (isProd && !isDebugEnabled) {
  console.log = () => { }
   console.warn = () => { };
  console.error = () => { };
}
//  Aniket Bhesaniya 🛠️  ~ 2025-12-23 ~ 015:14 PM
if (isProd && !isDebugEnabled && typeof window !== 'undefined') {
  const hook = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (hook) {
    hook.onCommitFiberRoot = () => {};
    hook.onCommitFiberUnmount = () => {};
  }
}
const Main = () => {
  const msalInstance = useRef(null)
  const [isMsalInitialized, setIsMsalInitialized] = useState(false); // New loading state
  // for ms login 

  useEffect(() => {
    const initializeMsal = async () => {
      let config = []
      let googleconfig = [] //  | Aniket Bhesaniya  ~ 2025-04-23 ~ 017:36 PM
      let subdomainname = IISMethods.getSubdomainName() ? IISMethods.getSubdomainName() : IISMethods.getCookiesData("loginInfo")?.subdomainname

      try {
        let msalData = IISMethods.getLocalData('msallogin')
        //  | Aniket Bhesaniya  ~ 2025-04-23 ~ 017:37 PM
        let googleData = IISMethods.getLocalData('googlelogin')
        const isEmpty = (obj) => !obj || Object.keys(obj).length === 0
        if (subdomainname && (isEmpty(msalData) || isEmpty(googleData))) {
          //  | Aniket Bhesaniya  ~ 2025-04-23 ~ 017:36 PM
          let credentials = await fetchMsalConfig(subdomainname)
          config = credentials?.mslogin || {}
          googleconfig = credentials?.googlelogin || {}
          IISMethods.setLocalData("msallogin", config)
          IISMethods.setLocalData("googlelogin", googleconfig)
        }
        else if (msalData && subdomainname) {
          config = msalData
        }
        else if (googleData && subdomainname) { //  | Aniket Bhesaniya  ~ 2025-04-23 ~ 017:37 PM
          googleconfig = googleData
        }
        else {
          IISMethods.clearLocalData('msallogin')

        }

        if (config) {
          const msalConfig = await getMsalConfig(config.ms_clientid, config.ms_tenantid, config.ms_redirecturl)
          const instance = new PublicClientApplication(msalConfig)
          // setMsalInstance(instance)
          msalInstance.current = instance
        } else {
          // setMsalInstance(null)
          msalInstance.current = null
        }
      } catch (e) {
        console.log(e)
      }
      setIsMsalInitialized(true)
    }
    
    initializeMsal()
  }, [])
  //  Aniket Bhesaniya 🛠️  ~ 2025-12-23 ~ 015:14 PM
//   // Disable right-click
// document.addEventListener('contextmenu', (e) => e.preventDefault());

// function ctrlShiftKey(e, keyCode) {
//   return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
// }

// document.onkeydown = (e) => {
//   // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
//   if (
//     event.keyCode === 123 ||
//     ctrlShiftKey(e, 'I') ||
//     ctrlShiftKey(e, 'J') ||
//     ctrlShiftKey(e, 'C') ||
//     (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))
//   )
//     return false;
// };

  if (isMsalInitialized) {
    if (!msalInstance.current) {
         return (
          <Provider store={store}>
            <Head />
            <BrowserRouter>
             <MemoryMonitor store={store} />
              <Router />
            </BrowserRouter>
          </Provider>

      )
    }
    else {
      return (
        <Provider store={store}>
          <MsalProvider instance={msalInstance.current}>
            <Head />
            <BrowserRouter>
            <MemoryMonitor store={store} />
              <Router />
            </BrowserRouter>
          </MsalProvider>
        </Provider>
      )
    }
  } else {
    return <LogoLoader />
  }



}
const root = createRoot(document.getElementById('root'));
root.render(<><Main /></>);
